import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import BlueprintTheme from 'blueprint/js/BlueprintTheme.js';
import { StyledNavTab } from '@bit/knotchinc.web-react-components.tabs';
import { StyledBadgeText, NewItemBadgeContainer } from 'components/Global/Badges/styled.js';
import backArrowIcon from 'images/icons/back-arrow.svg';

const { transition } = BlueprintTheme;

export const EntityLogo = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 100%;
  height: ${({ isHub }) => isHub ? '80px' : '200px'};
  width: ${({ isHub }) => isHub ? '80px' : '200px'};
  background: ${({ imageUrl }) => `url('${imageUrl}') center center no-repeat`};
  background-color: white;
  background-size: contain;
  position: absolute;
  top: ${({ isHub }) => isHub ? '169px' : '140px'};
`;

export const PartnershipLogo = styled(EntityLogo)`
  height: 53px;
  width: 53px;
  top: 190px;
  display: inline-block;

  &:nth-of-type(2) {
    margin-left: 45px;
  }
`;

export const TitleContainer = styled.div`
  font-weight: 300;
  font-size: 36px;
  line-height: 52px;
`;

export const HubTitleContainer = styled(TitleContainer)`
  line-height: 40px;
`;

export const PrimaryTitle = styled.div`
  display: inline-block;
  color: white;
  margin-right: 11px;
`;

export const Subtitle = styled.div`
  /* display: block; */
  color: ${({ theme }) => theme.colors.palette[7]};
`;

export const SecondaryTitle = styled.div`
  display: inline-block;
  color: ${({ theme }) => theme.colors.palette[7]};
`;

export const HubTitle = styled.div`
  display: block;
  color: ${({ theme }) => theme.colors.palette[5]};
`;

export const HubSubTitle = styled.div`
  color: white;
`;

export const PlaybookLink = styled(Link)`
  border: 1px solid #A958FA;
  border-radius: 20px;
  font-weight: 500;
  vertical-align: super;
  font-size: 9px;
  line-height: 13px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  text-decoration: none;
  padding: 9px 16px;
  color: #FFFFFF;
  transition: all .5s ${transition.bezier};
  margin-left: 8px;
  vertical-align: baseline;

  &:hover {
    background-color: ${({ theme }) => theme.colors.palette[7]};
  }
`;

export const PageTabContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 40px;
  z-index: 2;

  ${({ theme }) => css`
  // This is specific styling for when a page Tab is active & has a "New" badge
    .active {
      ${StyledBadgeText} {
        color: white;
      }
      ${NewItemBadgeContainer} {
        background: ${theme.colors.palette[3]};
      }
    }
  `};
`;

export const StyledBackTab = styled(StyledNavTab)`
  background-color: transparent;
  border: 2px solid #6994BB;
  border-top-right-radius: 6px;
  border-right: none;
  border-bottom: none;
  position: absolute;
  bottom: 0;
  height: 45px;
  max-width: unset;
  width: 255px;
  vertical-align: middle;
  line-height: 45px;
  font-weight: bold;
  z-index: 3;

  &:hover {
    background: transparent;
    height: 50px;

    &:after {
      height: 54px;
      transform: translateX(4px) rotate(-24deg) translateY(-7px);
    }
  }

  &:after {
    border-width: 2px;
    height: 49px;
    right: -11px;
    transform: translateX(2px) rotate(-24deg) translateY(-7px);
    border-radius: 10px;
  }

  &:before {
    content: '';
    width: 14px;
    height: 10px;
    margin-right: 10px;
    background: url('${backArrowIcon}');
    background-position: center;
    background-repeat: no-repeat;
  }
`;
